import makeStyles from '@mui/styles/makeStyles'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import React from 'react'
import { TopBarTopLinkProps } from '../../types'
import { ListItemWrapper } from '../list-item-wrapper'

const useStyles = makeStyles((theme) => ({
  activeSubMenuText: {
    color: theme.variables.colors.activeSubMenuText,
    paddingLeft: 0
  }
}))

export interface MobileListItemProps {
  link: Required<Pick<TopBarTopLinkProps, 'key' | 'subMenu' | 'translationId'>>
  index: number
  isCurrentMenuOpen: boolean
  handleClick: (index: number) => void
}

export const MobileListItem = ({
  link,
  index,
  isCurrentMenuOpen,
  handleClick
}: MobileListItemProps) => {
  const classes = useStyles()

  return (
    <ListItemWrapper
      listItemProps={{ onClick: () => handleClick(index) }}
      listItemTextProps={{
        classes: { inset: classes.activeSubMenuText },
        inset: isCurrentMenuOpen,
        translationId: link.translationId
      }}
      icon={isCurrentMenuOpen ? <ExpandLess /> : <ExpandMore />}
    />
  )
}
